import { render } from "./LineUps.vue?vue&type=template&id=88b7d57e"
import script from "./LineUps.vue?vue&type=script&lang=js"
export * from "./LineUps.vue?vue&type=script&lang=js"

import "./LineUps.vue?vue&type=style&index=0&id=88b7d57e&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__